import { api } from '@/api';
import { TemplateType } from './types';

/**
 * Begins a new template upload. The backend returns a SAS `uploadPath` +
 * `uploadToken` the client PUTs the file to (see `useUploadTemplate`), plus
 * the `templateId` used to later confirm the upload via `upload-complete`.
 */
export interface TemplateGetUploadProps {
  templateType: TemplateType;
  documentName: string;
}

export interface TemplateGetUploadResponse {
  uploadToken: string;
  uploadPath: string;
  templateId: string;
  templateName: string;
}

const templateGetUploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postTemplateGetUpload: builder.query<TemplateGetUploadResponse, TemplateGetUploadProps>({
      query: ({ templateType, documentName }: TemplateGetUploadProps) => ({
        url: `template/get-upload`,
        method: 'POST',
        body: {
          templateType,
          documentName,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostTemplateGetUploadQuery } = templateGetUploadApi;
